import { api, CustomAxiosRequestConfig } from "./http-client";
import { LoginResponse, User } from "../interfaces/user.interface";
import { API_PATHS } from "../config/api.config";

export interface OtpRequiredResponse {
  requiresOtp: true;
  otpToken: string;
}

export type LoginResult = LoginResponse | OtpRequiredResponse;

export const authService = {
  getSetupStatus: async (): Promise<{ isSetup: boolean }> => {
    const response = await api.request<{ isSetup: boolean }>({
      url: API_PATHS.AUTH.SETUP_STATUS,
      method: "GET",
    });
    return response.data;
  },

  setup: async (data: Record<string, unknown>): Promise<void> => {
    await api.request({
      url: API_PATHS.AUTH.SETUP,
      method: "POST",
      data,
    });
  },

  login: async (email: string, password: string): Promise<LoginResult> => {
    const response = await api.request<LoginResult>({
      url: API_PATHS.AUTH.LOGIN,
      method: "POST",
      data: { email, password },
      skipAuthRedirect: true,
    });
    return response.data;
  },

  verifyLoginOtp: async (otpToken: string, code: string): Promise<LoginResponse> => {
    const response = await api.request<LoginResponse>({
      url: API_PATHS.AUTH.VERIFY_OTP,
      method: "POST",
      data: { otpToken, code },
      skipAuthRedirect: true,
    });
    return response.data;
  },

  forgotPassword: async (email: string): Promise<{ message: string }> => {
    const response = await api.request<{ message: string }>({
      url: API_PATHS.AUTH.FORGOT_PASSWORD,
      method: "POST",
      data: { email },
      skipAuthRedirect: true,
    });
    return response.data;
  },

  resetPassword: async (token: string, email: string, newPassword: string): Promise<{ message: string }> => {
    const response = await api.request<{ message: string }>({
      url: API_PATHS.AUTH.RESET_PASSWORD,
      method: "POST",
      data: { token, email, newPassword },
      skipAuthRedirect: true,
    });
    return response.data;
  },

  getProfile: async (config?: CustomAxiosRequestConfig): Promise<User> => {
    const response = await api.request<User>({
      url: API_PATHS.AUTH.PROFILE,
      method: "GET",
      ...config,
    });
    return response.data;
  },

  logout: async (): Promise<void> => {
    await api.request({
      url: API_PATHS.AUTH.LOGOUT,
      method: "POST",
    });
  },
};
